import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Inter hospedada no proprio projeto: sem requisicao a terceiro, sem mexer no
// CSP e sem enviar IP de fornecedor para fora. O arquivo traz os subsets com
// unicode-range, entao o navegador baixa so o latino (~47 KB).
import '@fontsource-variable/inter/wght.css';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado no index.html.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
